import { DynamicYield } from '@packages/shared/src/ui/DynamicYield/DynamicYield';
import type { DynamicYieldType } from './types';

export const CmsDynamicYield = ({ data }: { data: DynamicYieldType }) => (
  <DynamicYield
    dataDyId={data.field_custom_id}
    style={{ margin: data.field_margin, padding: data.field_padding }}
  />
);
